import React, { Component } from 'react'
import Button from 'components/button/button'
import { connect } from 'react-redux'

import {
	openModal,
	createOrReturnChat,
	changeTitle,
	getWeather,
	getDashboardData,
	createTodo,
	getAllProjectProgress,
	dashboardQuery,
	updateUserSubscriber,
} from 'state/actions'

import {
	getCurrentUser,
	isPremium,
	getCurrentAccount,
	getUserRoles,
	getApplicableProjects,
	getAccountProjects
} from 'state/selectors'

import { withRouter } from 'react-router'

import DropdownMenu from 'components/dropdown-menu/dropdown-menu'

import moment from 'moment'

import DashboardTasks from './dashboard-tasks'
import DashboardProjectProgress from './dashboard-project-progress'
import DashboardCalendar from './dashboard-calendar'
import DashboardTimeTracking from './dashboard-time-tracking'
import DashboardAnnouncement from './dashboard-announcement'
import DashboardWellness from './dashboard-wellness'
import DashboardOnboarding from './dashboard-onboarding'

import Onboarder from 'components/onboarder/onboarder'

import queryString from 'query-string'

import MobileFooterButtons from 'components/mobile/footer-buttons'

import Icon from 'components/icon/icon'

import Scroll from 'react-scroll'

import { some } from 'lodash'

import {
	formatByTimeZone,
	getOffset,
	isMobile,
	getDashboardOnboardingSteps
} from 'utils'

class Dashboard extends Component {
	state = {
		weatherData: '',
		weatherIcon: '',
		weatherTemperature: '',
		isLoading: false,
		queries: null,
		focusedWidget: null
	}

	scroll = Scroll.animateScroll

	widgetRefs = {}

	UNSAFE_componentWillMount() {
		const {
			changeTitle,
			getWeather,
			accountData,
			match
		} = this.props

		changeTitle('Dashboard')

		getWeather(data => {
			this.setState({
				weatherData: data.summary,
				weatherIcon: data.icon,
				weatherTemperature: data.apparentTemperature,
				weatherFormat: data.format == 'us' ? 'F' : 'C'
			})
		})

		if (accountData) {
			// These checks are because it'll otherwise try to request data while mid-swap accounts
			const slugFromUrl = match.path.replace('/dashboard', '').replace('/', '')
			const slugFromAccount = accountData.slug

			if (slugFromUrl == slugFromAccount) {
				this.getData(accountData)
			}
		}
	}

	UNSAFE_componentWillUpdate = (nextProps, nextState) => {
		if (this.props.accountData.id !== nextProps.accountData.id) {
			this.getData(nextProps.accountData)
		}
	}

	componentDidMount = _ => {
		const {
			location,
			openModal
		} = this.props

		const thisQueryString = location.search
		const queries = queryString.parse(thisQueryString)

		if (queries.event && parseInt(queries.event) && this.widgetRefs.calendar) {
			this.scrollToCalendar()
		}

		this.setState({
			queries
		})

		if (window.campaign && window.campaign === 'calendar') {
			delete window.campaign

			this.scrollToCalendar()

			openModal('create', 'event', null)
		}
	}

	scrollToCalendar = _ => {
		setTimeout(_ => {
			const newScrollTop = (getOffset(this.widgetRefs.calendar).top - 100)

			this.scroll.scrollTo(newScrollTop, {
				duration: 2000,
				smooth: "easeInOutQuint",
			})

			this.setState({
				focusedWidget: 'calendar'
			})

			setTimeout(() => {
				this.setState({
					focusedWidget: null
				})
			}, 5000)
		}, 100)
	}

	getData = account => {
		if (!account) {
			return
		}

		this.setState({
			isLoading: true
		})

		this.props.getDashboardData(account.id, _ => {
			this.setState({
				isLoading: false
			})
		}, this.props.token ? this.props.token : null)
	}

	newProject = _ => {
		this.props.openModal('create', 'project', {
			account_id: this.props.currentAccount.id,
			folderChain: this.props.folderChain
		})
	}

	addUser = _ => {
		this.props.openModal('invite', 'invite')
	}

	handleAccountChange = accountId => {
		const account = this.props.allAccounts[accountId]
		this.props.history.push('/' + account.slug)
	}

	handleCreateAccount = _ => {
		this.props.openModal('register', 'register', {
			isSecondaryAccount: true,
			canGoBack: true
		})
	}

	postAnnouncement = _ => {
		this.props.openModal('feedback', 'feedback', {
			isAnnouncement: true
		})
	}

	getLatestAnnouncement = _ => {
		const {
			allBulletins,
			userData,
			accountData
		} = this.props

		if (accountData && accountData.bulletins && accountData.bulletins.length) {
			let lastSeenBulletinId = -1

			if (userData.last_dismissed_bulletin_ids && userData.last_dismissed_bulletin_ids[accountData.id]) {
				lastSeenBulletinId = userData.last_dismissed_bulletin_ids[accountData.id]
			}

			accountData.bulletins && accountData.bulletins.sort((a, b) => {
				return a - b
			})

			const lastBulletinId = (accountData.bulletins && accountData.bulletins.length) ? accountData.bulletins[(accountData.bulletins.length - 1)] : null

			if (lastBulletinId && (lastBulletinId > lastSeenBulletinId || !lastSeenBulletinId)) {
				return allBulletins[lastBulletinId]
			}
		}

		return null
	}

	hasTimeTrackedProjects = _ => {
		let hasTimeTrackedProjects = false

		const {
			allTeams,
			userData,
			userRoles,
			accountProjects
		} = this.props

		if (!accountProjects) {
			return false
		}

		accountProjects.some(project => {
			if (!project || !project.has_timing) {
				return
			}

			let canAccessProject = project.is_public || userRoles.admin || userRoles.pm

			if (!canAccessProject) {
				project.teamIds && project.teamIds.some(teamId => {
					const team = allTeams[teamId]

					if (team.userIds && team.userIds.indexOf(userData.id) !== -1) {
						canAccessProject = true

						return true
					}
				})
			}

			if (canAccessProject) {
				hasTimeTrackedProjects = true
			}
		})

		return hasTimeTrackedProjects
	}

	getSelectedAccountId = _ => {
		const {
			location,
			allAccounts,
			accountData
		} = this.props

		const currentAccountSlug = location.pathname.split('/')[1]

		if (accountData.slug == currentAccountSlug) {
			return accountData.id
		}

		let accountId = null

		some(allAccounts, account => {
			if (account.slug == currentAccountSlug) {
				accountId = account.id
				return true
			}
		})

		return accountId
	}

	hasFullyOnboarded = () => {
		const { userData, accountData, userRoles } = this.props

		if (!userData || !userData.onboarded_enums || !accountData) {
			return false
		}

		if (userRoles && userRoles.guest) {
			return true
		}

		const onboardingSteps = getDashboardOnboardingSteps(accountData, userData)

		const { onboarded_enums } = userData

		let hasDoneAllSteps = true

		onboardingSteps.some(item => {
			if (!~onboarded_enums.indexOf(item.key) && item.key !== 'HOP_IN') {
				hasDoneAllSteps = false
				return true
			}
		})

		return hasDoneAllSteps
	}

	render() {
		const {
			weatherTemperature,
			weatherFormat,
			weatherData,
			weatherIcon,
			queries,
			focusedWidget
		} = this.state

		const {
			accountProjects,
			userData,
			createTodo,
			allAccounts,
			allTodoDays,
			allTodos,
			allTasks,
			allMilestones,
			allProjects,
			allFolders,
			dashboardData,
			createOrReturnChat,
			getAllProjectProgress,
			accountData,
			history,
			match,
			openModal,
			isPremium,
			isGuest,
			userRoles,
			allUsers,
			folderChain,
			currentAccount
		} = this.props

		if (!dashboardData) {
			return null
		}

		const timeHours = formatByTimeZone(moment(), 'HH')

		let timeWord

		if (timeHours < 12) {
			timeWord = 'morning'
		} else if (timeHours < 18) {
			timeWord = 'afternoon'
		} else {
			timeWord = 'evening'
		}

		const greeting = `Good ${timeWord}, ${userData.first_name}.`

		const mobileButtonProps = [
			{
				icon: 'star-o',
				label: 'New project',
				callback: this.newProject,
				level: 'low',
			},
			{
				icon: 'fe-mail',
				label: 'New chat',
				callback: _ => { createOrReturnChat(null, null, _ => { }) },
				level: 'high',
			}
		]

		const canPostAnnouncement = isPremium && (userRoles.pm || userRoles.admin)

		const latestAnnouncement = this.getLatestAnnouncement()

		const hasTimeTrackedProjects = this.hasTimeTrackedProjects()

		return (
			<div className="dashboard-container">
				<MobileFooterButtons buttons={mobileButtonProps} />
				<header className="main-header">
					<h1>
						{greeting}
					</h1>
					<span className="sub-title-area">
						<DropdownMenu
							isObjects={true}
							selectableItems={(userData && userData.accounts) ? userData.accounts.map(accountId => {
								return allAccounts[accountId]
							}) : []}
							hasImage={true}
							selectedItemId={this.getSelectedAccountId()}
							handleChange={this.handleAccountChange}
							handleCreateNew={this.handleCreateAccount}
							parentType="organisation"
							canCreateNew={true}
						/>
						{isGuest ?
							<div className="external-indicator tooltip-trigger">
								<Icon name="user" />
								<span>
									Guest
								</span>
							</div>
							: null}
					</span>
					<div className="date-weather-container">
						<p>
							{formatByTimeZone(moment(), 'dddd, Do MMMM')}
						</p>
						{
							!weatherTemperature ?
								<span>
									Weather loading...
								</span>
								:
								<span>
									<img src={document.base + "/images/icons/weather/" + weatherIcon + ".png"} />
									{(Math.round(weatherTemperature)) + '°' + weatherFormat + ' • ' + weatherData}
								</span>
						}
					</div>
				</header>
				<main className="clear">
					{(latestAnnouncement && !userRoles.guest) ?
						<div className="row">
							<DashboardAnnouncement
								announcement={latestAnnouncement}
								userData={userData}
								allUsers={allUsers}
								folderChain={folderChain}
								currentAccount={currentAccount}
							/>
						</div>
						: null}
					<div className="row">
						<div className="left-column">
							<div className="widget box dashboard-tasks">
								<DashboardTasks
									createTodo={createTodo}
									allTodoDays={allTodoDays}
									allTodos={allTodos}
									userData={userData}
									allTasks={allTasks}
									allMilestones={allMilestones}
									allProjects={allProjects}
									recentlyAdded={dashboardData.recentlyAddedTasks}
									upcoming={dashboardData.upcomingTasks}
									accountData={accountData}
									isPremium={isPremium}
								/>
							</div>
						</div>
						<div className="right-column">
							{
								!isGuest ?
									<ul className="button-shelf">
										<li>
											<Onboarder type='CREATED_PROJECT' direction="right" />
											<Button
												size="big"
												label="New project"
												icon="star-o"
												callback={this.newProject}
											/>
										</li>
										<li>
											<Onboarder type='POSTED_ANNOUNCEMENT' direction="top-right" />
											{canPostAnnouncement ?
												<Button
													size="big"
													label="Announce"
													icon="bullhorn"
													callback={this.postAnnouncement}
												/>
												:
												<Button
													size="big"
													label="New chat"
													icon="fe-mail"
													callback={_ => { createOrReturnChat(null, null, _ => { }) }}
												/>
											}
										</li>
										<li>
											<Button
												size="big"
												label="Invite"
												icon="fe-user-plus"
												callback={_ => { this.addUser() }}
											/>
										</li>
									</ul>
									: null
							}
							{!isMobile() &&
								this.hasFullyOnboarded() ?
								<DashboardWellness
									user={userData}
								/>
								:
								<DashboardOnboarding
									user={userData}
									account={accountData}
								/>
							}
						</div>
					</div>
					{!isMobile() &&
						<React.Fragment>
							{!userRoles.guest &&
								<div className={`row`}>
									<div ref={ref => this.widgetRefs.calendar = ref}>
										<DashboardCalendar
											accountData={accountData}
											allTasks={allTasks}
											allProjects={allProjects}
											allMilestones={allMilestones}
											allFolders={allFolders}
											userData={userData}
											history={history}
											match={match}
											openModal={openModal}
											queries={queries}
											isFocused={focusedWidget === 'calendar'}
										/>
									</div>
								</div>
							}
							{hasTimeTrackedProjects &&
								<div className={'row'}>
									<DashboardTimeTracking
										userData={userData}
										allTasks={allTasks}
										allProjects={allProjects}
										allMilestones={allMilestones}
										openModal={openModal}
										canEdit={true}
									/>
								</div>
							}
						</React.Fragment>
					}
					{
						!isGuest ?
							<div className="widget box dashboard-project-progress">
								<DashboardProjectProgress
									getAllProjectProgress={getAllProjectProgress}
									accountData={accountData}
									history={history}
									match={match}
									projectIds={dashboardData.projects}
									allProjects={allProjects}
									accountProjects={accountProjects}
									allFolders={allFolders}
									userData={userData}
								/>
							</div>
							: null
					}
				</main>
			</div>
		);
	}

}

const mapStateToProps = state => {
	return {
		allAccounts: state.account.entities.accounts,
		allTasks: state.account.entities.tasks,
		allMilestones: state.account.entities.milestones,
		allProjects: getApplicableProjects(state),
		allFolders: state.account.entities.folders,
		allTodoDays: state.account.entities.todo_days,
		allTodos: state.account.entities.todos,
		allBulletins: state.account.entities.bulletins,
		allUsers: state.account.entities.users,
		allTeams: state.account.entities.teams,
		userData: getCurrentUser(state),
		dashboardData: state.account.entities.dashboardData ? state.account.entities.dashboardData[undefined] : null,
		accountData: getCurrentAccount(state),
		token: state.auth.token,
		isPremium: isPremium(state),
		userRoles: getUserRoles(state),
		accountProjects: getAccountProjects(state)
	}
}

export default withRouter(connect(mapStateToProps, {
	openModal,
	createOrReturnChat,
	changeTitle,
	getWeather,
	getDashboardData,
	createTodo,
	getAllProjectProgress,
	dashboardQuery,
	updateUserSubscriber,
})(Dashboard))